import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ro from '../../assets/locales/ro/translation.json';

i18n.use(initReactI18next).init({
  lng: 'ro',
  resources: {
    ro,
  },
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
